import Layout from '../components/Layout';
import Container  from 'react-bootstrap/Container';
function Blog() {
    return (
        <>
            <Layout>
            <Container>
                Blog
            </Container>
            </Layout>
        </>
    );
}

export default Blog;